import Vue from 'vue'
import { axios } from '@/utils/request'
import signMd5Utils from '@/utils/encryption/signMd5Utils'
import { apiEncrypt } from '@/utils/encryption/aesEncrypt'
import { OpenApiEncrypt } from '@/utils/config/SysBaseConfig'


//post
export function postAction(url, parameter, encrypt = false) {
  let sign = signMd5Utils.getSign(url, parameter)
  //将签名和时间戳，添加在请求接口 Header
  let signHeader = { 'X-Sign': sign, 'X-TIMESTAMP': signMd5Utils.getDateTimeToString() }
  //update-begin-author:qjh date: 2024-08-12 11:06:53 for: 对内容进行加密
  //需要判断什么时候加密
  if (OpenApiEncrypt && encrypt) {
    //传参为true时需要对内容进行加密
    parameter = apiEncrypt(JSON.stringify(parameter))
  }
  //update-end-author:qjh date: 2024-08-12 11:06:53 for: 对内容进行加密
  return axios({
    url: url, method: 'post', data: parameter, contentType: 'application/json', headers: signHeader
  })
}

//post method= {post | put}
export function httpAction(url, parameter, method, encrypt = false) {
  let sign = signMd5Utils.getSign(url, parameter)
  //将签名和时间戳，添加在请求接口 Header
  let signHeader = { 'X-Sign': sign, 'X-TIMESTAMP': signMd5Utils.getDateTimeToString() }

  //update-begin-author:qjh date: 2024-08-12 11:06:53 for: 对内容进行加密
  //需要判断什么时候加密
  if (OpenApiEncrypt && encrypt) {
    //传参为true时需要对内容进行加密
    if (method == 'post' || method == 'POST' || method == 'put' || method == 'PUT') {//防止误操作
      parameter = apiEncrypt(JSON.stringify(parameter))
    }
  }
  //update-end-author:qjh date: 2024-08-12 11:06:53 for: 对内容进行加密

  return axios({
    url: url, method: method, data: parameter, headers: signHeader
  })
}


//put
export function putAction(url, parameter, encrypt = false) {
  //update-begin-author:qjh date: 2024-08-12 11:06:53 for: 对内容进行加密
  //需要判断什么时候加密
  if (OpenApiEncrypt && encrypt) {
    //传参为true时需要对内容进行加密
    parameter = apiEncrypt(JSON.stringify(parameter))
  }
  //update-end-author:qjh date: 2024-08-12 11:06:53 for: 对内容进行加密
  return axios({
    url: url, method: 'put', data: parameter
  })
}

//get
export function getAction(url, parameter) {
  let sign = signMd5Utils.getSign(url, parameter)
  // //将签名和时间戳，添加在请求接口 Header
  let signHeader = { 'X-Sign': sign, 'X-TIMESTAMP': signMd5Utils.getDateTimeToString() }

  return axios({
    url: url, method: 'get', params: parameter, headers: signHeader
  })
}

//delete
export function deleteAction(url, parameter) {
  return axios({
    url: url, method: 'delete', params: parameter
  })
}


/**
 * 下载文件
 * @param url 文件路径
 * @param fileName 文件名
 * @param parameter
 * @returns {*}
 */
export function downloadFile(url, fileName, parameter) {
  return downFile(url, parameter).then((data) => {
    if (!data || data.size === 0) {
      Vue.prototype['$message'].warning('文件下载失败')
      return
    }
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(new Blob([data]), fileName)
    } else {
      let url = window.URL.createObjectURL(new Blob([data]))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) //下载完成移除元素
      window.URL.revokeObjectURL(url) //释放掉blob对象
    }
  })
}


/**
 * 获取文件服务访问路径
 * @param avatar
 * @param subStr
 * @returns {*}
 */
export function getFileAccessHttpUrl(avatar, subStr) {
  if (!subStr) subStr = 'http'
  
  try {
    if (avatar && avatar.startsWith(subStr)) {
      return avatar
    } else {
      if (avatar && avatar.length > 0 && avatar.indexOf('[') == -1) {
        return window._CONFIG['staticDomainURL'] + '/' + avatar
      }
    }
  } catch (err) {
    return
  }
}
